export default "__VITE_ASSET__D5p$IKdx__"